export default __webpack_public_path__ + "static/media/caseSlide6.8f13115d.png";